import {Directive} from 'vue';
import moment from 'moment';

export const formatDate: { name: string, directive: Directive } = {
  name: 'format-date', directive: (el, binding) => {
    if (binding.value === null || binding.value === '' || binding.value === undefined) {
      el.innerHTML = '';
      return;
    }
    const date = moment(binding.value);
    let format = 'DD.MM.YYYY';
    if (/\d{1,2}:\d{2}/.test(binding.value)) {
      format = 'DD.MM.YYYY HH:mm';
    }
    el.innerHTML = date.format(format);
  },
};
